export const baseInputVariantsSize40dpBaseHeight = "2.5rem";
export const baseInputVariantsFloatingLabelTrueLabelWrapperPx = "0.25rem";
export const baseInputVariantsFloatingLabelTrueLabelWrapperBgColor = "#fff";
export const baseInputVariantsFloatingLabelTrueLabelWrapperPositionX = "0.75rem";
export const baseInputVariantsFloatingLabelTrueLabelWrapperPositionY = "-8px";
export const baseInputVariantsFloatingLabelTrueLabelWrapperResizingW = "resizing-w-hug";
export const baseInputVariantsFloatingLabelTrueLabelTypography = "400 0.75rem/1rem Inter";
export const baseInputVariantsStateHoverBaseBgColor = "#f3faf9";
export const baseInputVariantsStateActiveBaseBgColor = "#e2f4f1";
export const baseInputVariantsStateFocusBaseOutlineColor = "#70c8be";
export const baseInputVariantsStateFocusBaseOutlineWidth = "0.125rem";
export const baseInputVariantsStateFocusBaseOutlineOffset = "-2px";
export const baseInputVariantsStateFocusLabelColor = "#29a197";
export const baseInputVariantsStateInvalidBaseOutlineColor = "#cf484c";
export const baseInputVariantsStateInvalidLabelColor = "#cf484c";
export const baseInputVariantsStateInvalidInputValueColor = "#cf484c";
export const baseInputVariantsStateInvalidPlaceholderColor = "#fa8b88";
export const baseInputVariantsStateInvalidHoverBaseBgColor = "#fff5f5";
export const baseInputVariantsStateInvalidActiveBaseBgColor = "#ffecea";
export const baseInputVariantsDisabledTrueBaseBgColor = "#eef0f3";
export const baseInputVariantsDisabledTrueBaseOutlineColor = "#dde1e8";
export const baseInputVariantsDisabledTrueLabelColor = "#a0acbe";
export const baseInputVariantsDisabledTrueInputValueColor = "#677893";
export const baseInputVariantsDisabledTruePlaceholderColor = "#a0acbe";
export const baseInputSlotsBasePx = "1rem";
export const baseInputSlotsBaseItemSpacing = "0.5rem";
export const baseInputSlotsBaseBgColor = "#fff";
export const baseInputSlotsBaseOutlineColor = "#bec6d3";
export const baseInputSlotsBaseBorderRadius = "0.5rem";
export const baseInputSlotsBaseOutlineWidth = "1px";
export const baseInputSlotsBaseOutlineOffset = "-1px";
export const baseInputSlotsBaseLayout = "layout-row";
export const baseInputSlotsBaseResizingW = "resizing-w-fill";
export const baseInputSlotsBaseResizingH = "resizing-h-fixed";
export const baseInputSlotsLabelColor = "#4c5f7c";
export const baseInputSlotsLabelTypography = "400 0.875rem/1.25rem Inter";
export const baseInputSlotsLabelFontWeight = "400";
export const baseInputSlotsInputValueColor = "#4c5f7c";
export const baseInputSlotsInputValueTypography = "400 0.875rem/1.25rem Inter";
export const baseInputSlotsInputValueFontWeight = "400";
export const baseInputSlotsPlaceholderColor = "#a0acbe";
export const baseInputSlotsPlaceholderTypography = "400 0.875rem/1.25rem Inter";
export const baseInputSlotsPlaceholderFontWeight = "400";
export const baseInputSlotsLabelWrapperPx = "0px";
export const baseInputSlotsLabelWrapperBgColor = "#ffffff00";
export const baseInputSlotsLabelWrapperBorderRadius = "0.25rem";
export const baseInputSlotsLabelWrapperResizingW = "resizing-w-fill";
export const baseInputSlotsLabelWrapperResizingH = "resizing-h-hug";
